import React from 'react'

import "../../assets/styles/nav/nav-footer-social.scss"

export default function FooterSocialNav() {
  return (
    <ul className="nav-social-menu">
      <li className="facebook">
        <a href="https://www.facebook.com/ShatterproofHQ" title="Facebook">Facebook</a>
      </li>
      <li className="twitter">
        <a href="https://twitter.com/ShatterproofHQ" title="Twitter">Twitter</a>
      </li>
      <li className="instagram">
        <a href="http://instagram.com/weareshatterproof" title="Instagram">Instagram</a>
      </li>
      <li className="email">
        <a href="mailto:info@shatterproof.org" title="Email">Email</a>
      </li>
    </ul>
  )
}
